import DossierContact from '@/contact/models/DossierContact';
import { Base64Image } from '@/shared/models/common';
import VehicleData from '@/vehicle/models/VehicleData';

export enum CheckInExtraJob {
  FLUIDS = 'fluids',
}

export interface CheckInData extends VehicleData {
  contact: DossierContact | null,
  canChangePriceAgreements: boolean,
  signature: Base64Image | null,
  hasConsumptionDataApproval: boolean,
  setDealerSignature: boolean,
  extraJobs: Array<CheckInExtraJob>,
}